module.exports = __webpack_public_path__ + "static/media/k3.bbf10ac9.webp";